import * as React from "react";
import * as ReactDOM from "react-dom";

import "./tailwind.pcss";

import App from "./components/App";

const root = document.getElementById("root");
ReactDOM.render(<App />, root);
